import React from 'react';

import { useLiveSite } from '../../hooks/useLiveSite';

import { LiveSiteCopyButton } from './LiveSiteCopyButton';

import './LiveSite.css';

/** Share flow: the project's live link, first, once it has one. */
export const LiveSiteShareRow: React.FC<{ projectId: string }> = ({ projectId }) => {
  const site = useLiveSite(projectId);

  if (!site?.url) return null;

  return (
    <div className="live-site-share">
      <div className="live-site-share__label">
        <span className={`live-site-dot${site.updating ? ' live-site-dot--updating' : ''}`} aria-hidden="true" />
        Live site
        <span className="live-site-share__hint">Updates on its own as your pages change</span>
      </div>
      <div className="share-modal__link-row">
        <input
          className="share-modal__link-input"
          value={site.url}
          readOnly
          aria-label="Live site link"
          onClick={(event) => (event.target as HTMLInputElement).select()}
        />
        <LiveSiteCopyButton url={site.url} className="share-modal__copy-btn" />
      </div>
    </div>
  );
};
